import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getGift } from "api/inventory";
import useShowSnackBar from "hooks/snackBar/useShowSnackBar";
import { useTranslation } from "react-i18next";
import { Gift } from "types/inventory";
import getFirebaseIdToken from "utils/getFirebaseIdToken";

const useGetGift = () => {
  const { t } = useTranslation();
  const showSnackBar = useShowSnackBar();
  const queryClient = useQueryClient();

  return useMutation<Gift, Error>(
    ["gift"],
    async () => {
      const token = await getFirebaseIdToken();
      if (token) {
        return getGift(token);
      }

      return Promise.reject(new Error("Invalid Firebase ID Token"));
    },
    {
      onSuccess: () => {
        showSnackBar({
          title: "Gift received",
          text: "Congratulations!",
        });
        return queryClient.invalidateQueries({ queryKey: ["inventory"] });
      },
      onError: () => {
        showSnackBar({
          title: t("notification.commonError.title"),
          text: t("notification.commonError.text"),
          variant: "error",
        });
      },
    },
  );
};

export default useGetGift;
